export const firebaseConfig = {
  apiKey: 'AIzaSyA9d5LvFmub3AWfgsxB_sPZcPP5q8KY6y8',
  authDomain: 'dossier-mk-prod.firebaseapp.com',
  projectId: 'dossier-mk-prod',
  storageBucket: 'dossier-mk-prod.firebasestorage.app',
  messagingSenderId: '339990606094',
  appId: '1:339990606094:web:12c26a9aae63c1f170e75f',
};
